import React, { useState } from 'react';
import { Modal, Button, Tag, Input } from 'antd';
import { CheckOutlined, DeleteOutlined, MailOutlined, ExclamationCircleOutlined, CloseOutlined, ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';
import api from '../../../../api';

const { confirm } = Modal;

function Cell({ order, position, onChange }) {
  const [showDetails, setShowDetails] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({
    price: order.price,
    firstName: order.firstName,
    lastName: order.lastName,
    phone: order.phone,
    email: order.email,
  });

  const styles = {
    position: 'absolute',
    left: position.left,
    right: position.right,
    width: position.width,
  }
  const startTime = new Date(order.timeStart)
  const endTime = new Date(order.timeEnd)

  const sentTicket = () => {
    try {
      if (window.confirm('Czy chcesz wysłać bilet do klienta?')) {
        const url = `/admin/orders/${order.id}/create_and_send_ticket`;
        window.open(url, '_blank').focus();
      }
    } catch (error) {
      alert('Upss.. coś poszło nie tak. Bilet nie został wysłany.')
    }
  }

  const deleteOrder = async () => {
    try {
      await api.deleteOrder(order.id);
      onChange();
    } catch (error) {
      alert('Upss.. coś poszło nie tak.')
    }
  }

  function showDeleteConfirm() {
    confirm({
      title: 'Na pewno chcesz usunąć rezerwacje?',
      icon: <ExclamationCircleOutlined />,
      content: 'Klient nie zostanie powiadomiony o usunięciu rezerwacji.',
      okText: 'Tak',
      okType: 'danger',
      cancelText: 'Nie',
      onOk() {
        deleteOrder()
      },
      onCancel() {},
    });
  }

  const setPaymentStatus = async status => {
    await api.changePaymentStatus(order.payment.id, status);
    onChange()

    setTimeout(() => {
      const cell = document.querySelector(`[data-order-id="${order.id}"]`);
      if (cell) cell.click();
    }, 500);
  }

  const submitEdit = async () => {
    try {
      await api.updateOrder(order.id, editData);
      onChange()

      setTimeout(() => {
        const cell = document.querySelector(`[data-order-id="${order.id}"]`);
        if (cell) cell.click();
      }, 500);
    } catch (error) {
      alert('Upss.. coś poszło nie tak.')
    }
  }

  const onFieldChange = (field, value) => {
    const data = {...editData};
    data[field] = value;
    setEditData(data);
  }
  const inline = { display: 'inline', width: 'auto' }

  return (
    <div 
      data-order-id={order.id}
      className={`og-cell ${order.payment.status} order-status-${order.status}`}
      style={styles} 
      title={order.equipmentsToOrder.map(eto => {
        return `${eto.equipmentToTrail.equipment.title} x ${eto.count} `
      })}
      onClick={(e) => e.target.classList.contains('og-cell') && setShowDetails(true)}
    >
      #{order.id} &nbsp; {order.firstName} {order.lastName}

      <Modal 
        title={`Rezerwacja nr ${order.id}`} 
        visible={showDetails} 
        okText={editMode ? 'Zapisz' : 'Edytuj'}
        cancelText="Zamknij"
        onOk={editMode ? submitEdit : () => setEditMode(true)} 
        onCancel={() => { setShowDetails(false); setEditMode(false); }}
        width={900}
      >

        {editMode ? (
          <div>
            <p>Imię <Input value={editData.firstName} style={inline}  onChange={e => onFieldChange('firstName', e.target.value)} />
            , nazwisko: <Input value={editData.lastName} style={inline} onChange={e => onFieldChange('lastName', e.target.value)} /></p>
            <p>Telefon: <Input value={editData.phone} style={inline} onChange={e => onFieldChange('phone', e.target.value)} /></p>
            <p>Email: <Input value={editData.email} style={inline} onChange={e => onFieldChange('email', e.target.value)} /></p>
            {order.payment.channelId === 1
              ? <p>Cena: <Input value={editData.price} style={inline} onChange={e => onFieldChange('price', e.target.value)} /> zł</p>
              : <p>Cena: <Input value={editData.price} style={inline} disabled /> zł</p>
            }
            
          </div>
        ) : (
          <div>
            <p>Imię, nazwisko: <b>{order.firstName} {order.lastName}</b></p>
            <p>Telefon: <a href={`tel:${order.phone}`}>{order.phone}</a></p>
            <p>Email: <a href={`mail:${order.email}`}>{order.email}</a></p>
            <p>Cena: <b>{order.price}</b> zł</p>
          </div>
        )}

        


        
        <p>Płatność: &nbsp;
          {order.payment.channelId === 1 && 'Gotówką'} 
          {order.payment.channelId === 2 && 'Online'}
        </p>
        <p>Status płatności:&nbsp;
          {order.payment.status === 'started' && <Tag color="processing"><ClockCircleOutlined /> Oczekuje na płatność</Tag>}
          {order.payment.status === 'completed' && <Tag color="success"><CheckOutlined /> Opłacono</Tag>}
        </p>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Ilość</th>
              <th>Sprzęt</th>
            </tr>
          </thead>
          <tbody>
            {order.equipmentsToOrder.map(eq => (
              <tr key={eq.id}>
                <td>{eq.count}</td>
                <td>{eq.equipmentToTrail.equipment.title}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <p>Czas rezerwacji:
        &nbsp;<b>{startTime.toLocaleString('pl', { dateStyle: 'full', timeStyle: 'short' })}</b>
        &nbsp;do <b>{endTime.toLocaleString('pl', { timeStyle: 'short' })}</b> </p>

        {order.payment.channelId === 1 && (
          <>
          {order.payment.status === 'completed'
            ? <Button type="primary" onClick={() => setPaymentStatus('started')} icon={<CloseOutlined />}>Oznacz jako nieopłacony</Button>
            : <Button type="primary" onClick={() => setPaymentStatus('completed')} icon={<CheckOutlined />}>Oznacz jako opłacony</Button>
          } &nbsp;
          </>
        )}
        
        {order.email && (
          <Button type="primary" icon={<MailOutlined />} onClick={sentTicket}>Wyślij bilet</Button>
        )} &nbsp;
        <Button type="primary" icon={<DeleteOutlined />} danger onClick={showDeleteConfirm}>Usuń</Button>

      </Modal>
    </div>
  );
}

export default Cell;